import { createSlice } from "@reduxjs/toolkit";

const initState = {
  conversations: [],
  messages: [],
  notifications: [],
};

const reducers = {
  getConversationList: (state: any, action: any) => {
    const items = action.payload.items;

    state.conversations = items;
  },
  getMessages: (state: any, action: any) => {
    const tempMessages = [...state.messages];
    const newMessages = action.payload.items;

    if (action.payload.updateList) {
      state.messages = newMessages;
    } else {
      state.messages = [...newMessages, ...tempMessages];
    }
  },
  sendMessage: (state: any, action: any) => {
    const tempMessages = [...state.messages];
    const newMessage = action.payload.item;

    tempMessages.push(newMessage);

    state.messages = tempMessages;
  },
  updateMessage: (state: any, action: any) => {
    const tempMessages = [...state.messages];
    const newItem = action.payload.item;

    const index = tempMessages.findIndex((item) => item.id === newItem.id);
    state.messages[index] = newItem;
  },
  deleteMessage: (state: any, action: any) => {
    const tempMessages = [...state.messages];
    const itemId = action.payload.id;
    const updatedList = tempMessages.filter((item) => item.id !== itemId);

    state.messages = updatedList;
  },

  getNotifications: (state: any, action: any) => {
    const items = action.payload.items;

    state.notifications = items;
  },
  updatNotifications: (state: any, action: any) => {
    const tempitems = [...state.notifications];
    const id = action.payload.id;

    const index = tempitems.findIndex((item) => item.id === id);
    state.notifications[index]["isRead"] = true;
  },
};

const userConverstions = createSlice({
  name: "userConverstions",
  initialState: initState,
  reducers,
});

export const {
  getConversationList,
  getMessages,
  sendMessage,
  updateMessage,
  deleteMessage,
  getNotifications,
  updatNotifications,
} = userConverstions.actions;

export default userConverstions.reducer;
